module.exports = __webpack_public_path__ + "2b381a0f845f24c29f0b3fe33e823e7d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/app-integration-instructions/local/app-types/open-vpn/index.html
// module id = 1145
// module chunks = 0